import React, { useState } from 'react';
import styles from './Items.module.css';
import { searchIcon } from '../../../../../assets/images';

export default function OutOfStockItems(props) {
  const { searchOutOfStockItems, popup, getOutOfStock, outOfStockItems, outOfStockMode, updateItemStock, outOfStockSearchList, onClose } = props;
  const [fieldValue, setFieldValue] = useState('');

  const search = () => {
    if (fieldValue.length === 0) return;
    searchOutOfStockItems && searchOutOfStockItems(popup.type, fieldValue);
    setFieldValue('');
  }

  const onItemClick = item => {
    updateItemStock && updateItemStock(item, popup.type);
  }

  const onSubmit = e => {
    e.preventDefault();
    search();
  };

  return (
    <div className={styles.mainWrapper}>
      <div className={styles.leftWrapper}>
        <div className={styles.leftHeader}>OUT OF STOCK</div>
        <div className={styles.leftItems}>
          {outOfStockItems.map((item) => {
            return <Item key={`leftItem-${item.id}`} item={item} onClick={() => onItemClick(item)} />
          })}
          <button className={styles.reloadBtn} onClick={() => getOutOfStock(outOfStockMode)}>RELOAD OUT OF STOCK</button>
        </div>
      </div>
      <div className={styles.rightWrapper}>
        <div className={styles.closePopupBtn} onClick={onClose}>X</div>
        <div className={styles.wrapper}>
          <div className={styles.searchWrapper}>
            <form onSubmit={onSubmit}>
              <input type="text" placeholder="Search with POS ID or Name" value={fieldValue} onChange={event => setFieldValue(event.target.value)} className={styles.textInput} />
            </form>
            <img src={searchIcon} alt="search" className={styles.searchIcon} onClick={search} />
          </div>
        </div>
        <div className={styles.container}>
          {outOfStockSearchList.map(item => {
            const isOutOfStock = outOfStockItems.find(i => i.id === item.id);
            return (
              <div key={`searchItem-${item.id}`} className={styles.cell} onClick={() => onItemClick(item)}>
                <div className={[styles.items, isOutOfStock ? styles.stockWidth : styles.inStockWidth].join(' ')}>{item.name}</div>
                {isOutOfStock ? <span className={styles.outOfStockRep}>86</span> : null}
              </div>
            )
          })}
        </div>
      </div>
    </div>
  );
};

const Item = (props) => {
  const { item, onClick } = props;
  return (
    <div className={styles.leftItem} onClick={onClick}>
      {item.name}
      <span className={styles.outOfStockRep}>86</span>
    </div>
  );
};
